var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
export var listTracksGql = function (channelId, fetchAdditionalInfo) { return gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query listTracks($channelId: String, $fetchAdditionalInfo: String) {\n      tracks(channelId: $channelId, fetchAdditionalInfo: $fetchAdditionalInfo)\n        @rest(type: \"[Track]\", path: \"/listtracks", "", "\", endpoint: \"query\") {\n        id\n        name\n        abstract\n        description\n        pathId\n        tubeId\n        channelId\n        parentTrackId\n        videosCount\n        orgId\n        createdAt\n        owner\n        status\n      }\n    }\n  "], ["\n    query listTracks($channelId: String, $fetchAdditionalInfo: String) {\n      tracks(channelId: $channelId, fetchAdditionalInfo: $fetchAdditionalInfo)\n        @rest(type: \"[Track]\", path: \"/listtracks", "", "\", endpoint: \"query\") {\n        id\n        name\n        abstract\n        description\n        pathId\n        tubeId\n        channelId\n        parentTrackId\n        videosCount\n        orgId\n        createdAt\n        owner\n        status\n      }\n    }\n  "])), Boolean(channelId) ? '?channelId=:channelId' : '', Boolean(fetchAdditionalInfo) ? "?fetchAdditionalInfo=" + fetchAdditionalInfo : ''); };
export var listTracksData = function (channelId, fetchAdditionalInfo) {
    return graphql(listTracksGql(channelId, fetchAdditionalInfo), {
        options: {},
        props: function (_a) {
            var data = _a.data;
            return ({
                listTracksQuery: data,
            });
        },
    });
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/queries/listTracks.ts
// module id = 769
// module chunks = 81